<template>
    <coach-required v-if="!libraryCoach" />
    <calendar-mobile v-else-if="isMobile" />
    <calendar-desktop v-else />
</template>

<script>

import { mapState } from "vuex";
import CalendarMobile from "@/components/coach/routines/CalendarMobile";
import CalendarDesktop from "@/components/coach/routines/CalendarDesktop";
import CoachRequired from "@/components/company/CoachRequired";
import { Screen } from "@/utils/Capacitor";

export default {
    components: {
        CalendarDesktop,
        CalendarMobile,
        CoachRequired,
    },
    computed: {
        ...mapState(['libraryCoach']),
    },
    mounted() {
        Screen.unlock()
    },
    beforeDestroy() {
        Screen.lockPortrait()
    },
}
</script>
